import React, { useEffect, useRef } from "react";

export default function Diagram() {
  const dashedRefs = [useRef(null), useRef(null)];

  useEffect(() => {
    dashedRefs.forEach((ref) => {
      if (ref.current) {
        const length = ref.current.getTotalLength();
        ref.current.style.strokeDasharray = length;
        ref.current.style.strokeDashoffset = length;
        setTimeout(() => {
          ref.current.style.transition = "stroke-dashoffset 2s ease";
          ref.current.style.strokeDashoffset = 0;
        }, 100);
      }
    });
  }, []);

  return (
    <div className="diagrams bg-sidom-blue">
      <div className=" flex flex-col lg:flex-row justify-center w-full items-center gap-10 mt-[70px] md:mt-[100px] lg:mt-[90px] mb-[70px] md:mb-[100px] lg:mb-[90px] px-2 md:px-0 lg:px-0">
        {/* SVG de Importación */}
        <svg
          width="100%"
          height="405"
          viewBox="0 0 456 405"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M220.065 355.677C287.282 355.677 341.771 301.188 341.771 233.971C341.771 166.755 287.282 112.266 220.065 112.266C152.849 112.266 98.3599 166.755 98.3599 233.971C98.3599 301.188 152.849 355.677 220.065 355.677Z"
            stroke="#ED7850"
            strokeWidth="2"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="dashed"
            strokeDasharray="8 8"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M215.124 84.1571V140.374C215.124 147.674 209.195 153.601 201.9 153.601H24.4476C17.1519 153.601 11.2236 147.674 11.2236 140.374V84.1571C11.2236 76.8567 17.1519 70.9297 24.4476 70.9297H201.9C209.195 70.9297 215.124 76.8567 215.124 84.1571Z"
            fill="white"
            stroke="#ED7850"
            strokeWidth="1.96331"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M52.0246 132.45C63.1712 132.45 72.2072 123.414 72.2072 112.268C72.2072 101.121 63.1712 92.085 52.0246 92.085C40.878 92.085 31.8418 101.121 31.8418 112.268C31.8418 123.414 40.878 132.45 52.0246 132.45Z"
            fill="#ED7850"
          ></path>
          <path
            d="M52.0273 123.764C58.3785 123.764 63.5272 118.615 63.5272 112.264C63.5272 105.912 58.3785 100.764 52.0273 100.764C45.676 100.764 40.5273 105.912 40.5273 112.264C40.5273 118.615 45.676 123.764 52.0273 123.764Z"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M48.5771 112.26L50.8771 114.56L55.4771 109.96"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M453.791 139.771V195.988C453.791 203.289 447.863 209.216 440.567 209.216H263.115C255.819 209.216 249.891 203.289 249.891 195.988V139.771C249.891 132.471 255.819 126.544 263.115 126.544H440.567C447.863 126.544 453.791 132.471 453.791 139.771Z"
            fill="white"
            stroke="#ED7850"
            strokeWidth="1.96331"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M290.692 188.065C301.839 188.065 310.875 179.029 310.875 167.882C310.875 156.735 301.839 147.699 290.692 147.699C279.545 147.699 270.509 156.735 270.509 167.882C270.509 179.029 279.545 188.065 290.692 188.065Z"
            fill="#ED7850"
          ></path>
          <path
            d="M290.698 179.379C297.049 179.379 302.198 174.23 302.198 167.879C302.198 161.528 297.049 156.379 290.698 156.379C284.346 156.379 279.198 161.528 279.198 167.879C279.198 174.23 284.346 179.379 290.698 179.379Z"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M287.248 167.875L289.548 170.175L294.148 165.575"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M453.791 313.292V369.509C453.791 376.809 447.863 382.736 440.567 382.736H263.115C255.819 382.736 249.891 376.809 249.891 369.509V313.292C249.891 305.991 255.819 300.064 263.115 300.064H440.567C447.863 300.064 453.791 305.991 453.791 313.292Z"
            fill="white"
            stroke="#ED7850"
            strokeWidth="1.96331"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M290.692 361.585C301.839 361.585 310.875 352.549 310.875 341.402C310.875 330.256 301.839 321.22 290.692 321.22C279.545 321.22 270.509 330.256 270.509 341.402C270.509 352.549 279.545 361.585 290.692 361.585Z"
            fill="#ED7850"
          ></path>
          <path
            d="M290.698 352.9C297.049 352.9 302.198 347.752 302.198 341.4C302.198 335.049 297.049 329.9 290.698 329.9C284.346 329.9 279.198 335.049 279.198 341.4C279.198 347.752 284.346 352.9 290.698 352.9Z"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M287.248 341.397L289.548 343.697L294.148 339.097"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M233.293 230.619V286.836C233.293 294.136 227.365 300.063 220.063 300.063H24.4442C17.1518 300.063 11.2236 294.136 11.2236 286.836V230.619C11.2236 223.319 17.1518 217.392 24.4442 217.392H220.063C227.365 217.392 233.293 223.319 233.293 230.619Z"
            fill="white"
            stroke="#ED7850"
            strokeWidth="1.93686"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <text
            fill="#ED7850"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
              fontSize: "16px",
              fontWeight: "bold",
              letterSpacing: "0em",
            }}
          >
            <tspan x="86.3184" y="245.857">
              Pago de{" "}
            </tspan>
            <tspan x="86.3184" y="264.857">
              Gravámenes y{" "}
            </tspan>
            <tspan x="86.3184" y="283.857">
              Oficialización
            </tspan>
          </text>
          <text
            fill="#ED7850"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
              fontSize: "16px",
              fontWeight: "bold",
              letterSpacing: "0em",
            }}
          >
            <tspan x="84.3184" y="109.275">
              Solicitud{" "}
            </tspan>
            <tspan x="84.3184" y="128.275">
              de fondos
            </tspan>
          </text>
          <path
            d="M52.0246 278.912C63.1712 278.912 72.2072 269.876 72.2072 258.73C72.2072 247.583 63.1712 238.547 52.0246 238.547C40.878 238.547 31.8418 247.583 31.8418 258.73C31.8418 269.876 40.878 278.912 52.0246 278.912Z"
            fill="#ED7850"
          ></path>
          <path
            d="M52.0302 270.227C58.3815 270.227 63.5302 265.079 63.5302 258.728C63.5302 252.376 58.3815 247.228 52.0302 247.228C45.679 247.228 40.5303 252.376 40.5303 258.728C40.5303 265.079 45.679 270.227 52.0302 270.227Z"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M48.5801 258.724L50.8801 261.024L55.4801 256.424"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <text
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
              fontSize: "25px",
              fontWeight: 600,
              letterSpacing: "0em",
            }}
          >
            <tspan x="151.359" y="41.7462">
              Importación
            </tspan>
          </text>
          <text
            fill="#ED7850"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
              fontSize: "16px",
              fontWeight: "bold",
              letterSpacing: "0em",
            }}
          >
            <tspan x="324.173" y="164.017">
              Generación{" "}
            </tspan>
            <tspan x="324.173" y="183.017">
              de VEPs
            </tspan>
          </text>
          <text
            fill="#ED7850"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
              fontSize: "16px",
              fontWeight: "bold",
              letterSpacing: "0em",
            }}
          >
            <tspan x="321.54" y="338.809">
              Acreditación{" "}
            </tspan>
            <tspan x="321.54" y="357.809">
              a cuenta
            </tspan>
          </text>
        </svg>

        {/* SVG de Exportación */}
        <svg
          width="100%"
          height="405"
          viewBox="0 0 456 405"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M222.671 340.28C289.888 340.28 344.377 285.79 344.377 218.574C344.377 151.358 289.888 96.8682 222.671 96.8682C155.455 96.8682 100.966 151.358 100.966 218.574C100.966 285.79 155.455 340.28 222.671 340.28Z"
            stroke="#ED7850"
            strokeWidth="2"
            strokeMiterlimit="1.5"
            strokeLinejoin="round"
            strokeDasharray="8 8"
            className="dashed"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M239.9 134.76V190.976C239.9 198.277 233.972 204.204 226.676 204.204H49.224C41.9283 204.204 36 198.277 36 190.976V134.76C36 127.459 41.9283 121.532 49.224 121.532H226.676C233.972 121.532 239.9 127.459 239.9 134.76Z"
            fill="white"
            stroke="#ED7850"
            strokeWidth="1.96331"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M76.801 183.053C87.9476 183.053 96.9836 174.017 96.9836 162.87C96.9836 151.724 87.9476 142.688 76.801 142.688C65.6543 142.688 56.6182 151.724 56.6182 162.87C56.6182 174.017 65.6543 183.053 76.801 183.053Z"
            fill="#ED7850"
          ></path>
          <path
            d="M76.8071 174.368C83.1583 174.368 88.3071 169.219 88.3071 162.868C88.3071 156.517 83.1583 151.368 76.8071 151.368C70.4558 151.368 65.3071 156.517 65.3071 162.868C65.3071 169.219 70.4558 174.368 76.8071 174.368Z"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M73.3569 162.864L75.6569 165.164L80.2569 160.564"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M426.898 231.802V288.018C426.898 295.319 420.97 301.246 413.674 301.246H236.222C228.926 301.246 222.998 295.319 222.998 288.018V231.802C222.998 224.501 228.926 218.574 236.222 218.574H413.674C420.97 218.574 426.898 224.501 426.898 231.802Z"
            fill="white"
            stroke="#ED7850"
            strokeWidth="1.96331"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M263.799 280.095C274.946 280.095 283.982 271.059 283.982 259.912C283.982 248.766 274.946 239.729 263.799 239.729C252.652 239.729 243.616 248.766 243.616 259.912C243.616 271.059 252.652 280.095 263.799 280.095Z"
            fill="#ED7850"
          ></path>
          <path
            d="M263.805 271.41C270.156 271.41 275.305 266.261 275.305 259.91C275.305 253.559 270.156 248.41 263.805 248.41C257.454 248.41 252.305 253.559 252.305 259.91C252.305 266.261 257.454 271.41 263.805 271.41Z"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M260.355 259.906L262.655 262.206L267.255 257.606"
            stroke="white"
            strokeWidth="2.29999"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <text
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
              fontSize: "25px",
              fontWeight: 600,
              letterSpacing: "0em",
            }}
          >
            <tspan x="151.359" y="50.3018">
              Exportación
            </tspan>
          </text>
          <text
            fill="#ED7850"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
              fontSize: "16px",
              fontWeight: "bold",
              letterSpacing: "0em",
            }}
          >
            <tspan x="107.437" y="159.883">
              Generación{" "}
            </tspan>
            <tspan x="107.437" y="178.883">
              de VEPs
            </tspan>
          </text>
          <text
            fill="#ED7850"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
              fontSize: "16px",
              fontWeight: "bold",
              letterSpacing: "0em",
            }}
          >
            <tspan x="296.108" y="266.274">
              Pago de LMAN
            </tspan>
          </text>
        </svg>
      </div>
    </div>
  );
}
